// hooks
import { useCallback, useEffect, useState, Fragment } from "react";
import useHttp from "hooks/use-http";
import { useNavigate } from "react-router-dom";

// material styles
import { Grid, IconButton, Tooltip } from "@mui/material";

// material icons
import { Edit } from "@mui/icons-material";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import TableCM from "components/shared/Table";
import PaginationCM from "components/shared/Pagination";

// helper
import GenerateHeadCell from "helper/generate-head-cell";

// constants
import { PAGINATION_LIMIT } from "constants";

// request methods
import { getRecordsDataRequest } from "api/requests/records";

// products head cells
const headCells = GenerateHeadCell("education_list");

function DisplayRecords() {
  const { request, loading, setLoading } = useHttp(false);

  const navigate = useNavigate();

  // states for filtered
  const [searchValue, setSearchValue] = useState("");

  // records data state
  const [recordsData, setRecordsData] = useState({
    data: [],
    count: 0,
  });

  // page state for pagination
  const [page, setPage] = useState(1);

  const handleSearch = (e) => setSearchValue(e);

  // handle onChange date
  const dateHandler = (value) =>
    value
      .split(" ")[0]
      .split("-")
      .map((item) => item)
      .join("/");

  // get all records data
  const getRecordsData = useCallback(async () => {
    setLoading(true);
    const res = await request({
      url: getRecordsDataRequest,
      values: {
        skip: searchValue ? 0 : (page - 1) * PAGINATION_LIMIT,
        limit: searchValue ? 100 : PAGINATION_LIMIT,
        search: searchValue || null,
      },
      isMulty: true,
    });

    setLoading(false);

    if (res) {
      if (res.data.count < 1) {
        return setRecordsData({
          count: res.data.count,
          data: [{ content: "هیچ اطلاعاتی یافت نشد" }],
        });
      }

      let transformedData = res.data.data.map((items) => ({
        id: items.id,
        title: items.title,
        subcategory: items?.category?.title ? items.category.title : "ثبت نشده",
        date: dateHandler(items.created_at.jdate),
        edit: (
          <IconButton
            color="primary"
            onClick={() => {
              navigate("/records/edit/" + items.id);
            }}
          >
            <Tooltip title="ویرایش" placement="top">
              <Edit />
            </Tooltip>
          </IconButton>
        ),
      }));

      setRecordsData({
        data: transformedData,
        count: res.data.count,
      });
    }
    setLoading(false);
  }, [page, searchValue]);

  useEffect(() => {
    getRecordsData();
  }, [getRecordsData]);
  return (
    <DrawerCM title="سوابق" onSearch={handleSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item xs={12} my={2}>
              <TableCM
                title="لیست سوابق"
                rows={recordsData.data}
                headCells={headCells}
                page={page}
                addRecords
                addRecordsSubCategory
                colspan={recordsData.count === 0 ? "11" : ""}
                fontSize="12px"
                cellFontSize="12px"
              />
            </Grid>
            {recordsData.count < 1 ? (
              " "
            ) : (
              <PaginationCM
                handleChange={(_, val) => setPage(val)}
                page={page}
                count={recordsData.count}
              />
            )}
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}

export default DisplayRecords;
